import React from 'react';
import PropTypes from 'prop-types';
import {Button, Modal} from 'react-bootstrap';
import {FaCalendarPlus, FaCheckCircle, FaEuroSign, FaLayerGroup, FaRedoAlt, FaShieldAlt, FaUsers, FaVideo} from 'react-icons/fa';
import {useTranslation} from 'react-i18next';

const PartnerPlanningGuideModal = ({show, onHide, includeVideoOptions}) => {
  const {t} = useTranslation();
  const sections = [
    {
      icon: FaCalendarPlus,
      title: t('PLANNING_GUIDE_SLOT_TYPE'),
      content: t('PLANNING_GUIDE_SLOT_TYPE_HELP')
    },
    {
      icon: FaUsers,
      title: t('PLANNING_GUIDE_PLAYERS'),
      content: t('PLANNING_GUIDE_PLAYERS_HELP')
    },
    {
      icon: FaEuroSign,
      title: t('PLANNING_GUIDE_PRICE'),
      content: t('PLANNING_GUIDE_PRICE_HELP')
    },
    ...(includeVideoOptions ? [{
      icon: FaVideo,
      title: t('PLANNING_GUIDE_VIDEO'),
      content: t('PLANNING_GUIDE_VIDEO_HELP')
    }] : []),
    {
      icon: FaRedoAlt,
      title: t('PLANNING_GUIDE_REPEAT'),
      content: t('PLANNING_GUIDE_REPEAT_HELP')
    },
    {
      icon: FaLayerGroup,
      title: t('PLANNING_GUIDE_EXISTING'),
      content: t('PLANNING_GUIDE_EXISTING_HELP')
    }
  ];

  return (
    <Modal show={show} onHide={onHide} size="lg" scrollable className="partner-planning-guide-modal">
      <Modal.Header closeButton>
        <div className="partner-planning-guide-title">
          <span><FaShieldAlt aria-hidden="true"/></span>
          <div>
            <small>{t('PARTNER_PLANNER')}</small>
            <Modal.Title>{t('PLANNING_GUIDE')}</Modal.Title>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="partner-planning-guide-intro">
          <strong>{t('PLANNING_GUIDE_INTRO_TITLE')}</strong>
          <p>{t('PLANNING_GUIDE_INTRO')}</p>
        </div>
        <div className="partner-planning-guide-grid">
          {sections.map(({icon: Icon, title, content}, index) => (
            <section key={title} className="partner-planning-guide-card">
              <span className="partner-planning-guide-card-icon"><Icon aria-hidden="true"/></span>
              <div>
                <small>{t('STEP_NUMBER', {number: index + 1})}</small>
                <h5>{title}</h5>
                <p>{content}</p>
              </div>
            </section>
          ))}
        </div>
        <div className="partner-planning-guide-check">
          <FaCheckCircle aria-hidden="true"/>
          <div><strong>{t('FINAL_CHECK')}</strong><span>{t('PLANNING_GUIDE_FINAL_CHECK')}</span></div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="partner-planning-guide-confirm" onClick={onHide}><FaCheckCircle/> {t('UNDERSTOOD')}</Button>
      </Modal.Footer>
    </Modal>
  );
};

PartnerPlanningGuideModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  includeVideoOptions: PropTypes.bool
};

PartnerPlanningGuideModal.defaultProps = {
  includeVideoOptions: true
};

export default PartnerPlanningGuideModal;
